import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';

const render_date = (data, type) => {
  if ('0000-00-00' === data) {
    return '';
  }
  if (type !== 'display') {
    return data;
  }

  if ('2999-12-31' === data) {
    return 'TBC';
  }

  try {
    const date = data.split('-');
    if (date.length === 3) {
      date.reverse();
      return date.join('-');
    }

  } catch (e) { }

  return '';
};

export default function MyOrders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        fetch('/api/my-orders')
            .then(res => res.json())
            .then(data => {
                setOrders(data);
                setLoading(false);
            })
            .catch(() => {
                setError('Failed to load orders');
                setLoading(false);
            });
    }, []);

    return (
        <div>
            {loading && <div>Loading...</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            {!loading && !error && (
                <Table striped bordered hover size="sm" className="mt-3">
                    <thead>
                        <tr>
                            <th>SO#</th>
                            <th>Order Date</th>
                            <th>Reference</th>
                            <th>Customer Name</th>
                            <th>Notes</th>
                            <th>ETA</th>
                            <th>Status</th>
                            <th>Container</th>
                            <th>Spa/Pergola Type</th>
                            <th>Serial Number</th>
                            <th>Print</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.length === 0 ? (
                            <tr><td colSpan={99} className="text-center">No orders found.</td></tr>
                        ) : orders.reverse().map((order, orderIdx) => {
                            const customerName = [order.ShipFirstName, order.ShipLastName].filter(_ => _).join(' ');
                            const datePlaced = render_date(order.DatePlaced.substr(0, 10), 'display') || '—';
                            const orderLines = order.OrderLine || [];
                            const rowspan = orderLines.length || 1;
                            // The Print column spans the whole order block (order lines + related serialised items).
                            const printRowspan = rowspan + (order.ProntoLines || []).length;

                            const line = orderLines[0] || {};

                            const renderLine = (line) => <>
                                        <td>{line.ProductDetails?.AvailabilityDescription || ''}</td>
                                        <td>{render_date(line.ProductDetails?.DateArrival, 'display')}</td> {/* ETA */}
                                        <td>{line.ProductDetails?.Misc07 || ''}</td> {/* TODO - Status */}
                                        <td>{line.ProductDetails?.Misc13 || ''}</td> {/* Container */}
                                        <td>{line.Quantity}x {line.Name || line.ProductName || '—'}</td>
                                        <td>{line.ProductDetails?.SKU !== line.ProductDetails?.AccountingCode ? line.SKU : ''}</td>
                                    </>;

                            return [
                                <tr key={`order-header-${orderIdx}`} style={{ borderTop: '2px solid green' }}>
                                    <td rowSpan={rowspan}>{order.ProntoSO}</td>
                                    <td rowSpan={rowspan}>{datePlaced}</td>
                                    <td rowSpan={rowspan}>{order.OrderID}</td>
                                    <td rowSpan={rowspan}>{order.CustomerName||customerName}</td>
                                    {renderLine(line)}
                                    <td rowSpan={printRowspan} className="text-center align-middle">
                                        {order.ProntoSO ? (
                                            <button
                                                className="btn btn-primary btn-sm"
                                                title="Open a printable Order Confirmation in a new tab"
                                                onClick={() => window.open('/api/print-sales-order?so=' + encodeURIComponent(order.ProntoSO) + '&sig=' + encodeURIComponent(order.PrintSig || ''), '_blank')}
                                            >
                                                Print
                                            </button>
                                        ) : ''}
                                    </td>
                                </tr>,
                                ...orderLines.slice(1).map((line, idx) => (
                                    <tr key={`orderline-${orderIdx}-${idx}`}>
                                        {renderLine(line)}
                                    </tr>
                                )),
                                ...order.ProntoLines.map((product, idx) => (
                                    <tr key={`pronto-product-${orderIdx}-${idx}`} style={{ backgroundColor: '#f0f8ff' }}>
                                        <td colSpan={4} style={{textAlign: 'right', fontWeight: 'bold'}}>Related serialised item:</td>
                                        <td>{product.AvailabilityDescription || ''}</td>
                                        <td>{render_date(product.DateArrival, 'display')}</td>
                                        <td>{product.Misc07 || ''}</td>
                                        <td>{product.Misc13 || ''}</td>
                                        <td>{product.Name || '—'}</td>
                                        <td>{product.SKU !== product.AccountingCode ? product.SKU : ''}</td>
                                    </tr>
                                ))
                            ];
                        })}
                    </tbody>
                </Table>
            )}
        </div>
    );
}
